import { GraphQLVehicleDeviceAssociationRequester } from '@cobliteam/api-lib';
import type { VehicleDeviceAssociationInfoInput, VehicleDeviceAssociationInfoResponse } from '@cobliteam/api-lib/src/__generated__/graphql';
import { useQuery } from '@tanstack/react-query';

export const QUERY_KEY = 'VEHICLE_DEVICE_ASSOCIATIONS';

// Lazy instantiation to avoid circular dependency issues
const getGraphQLVehicleDeviceAssociationRequester = () => new GraphQLVehicleDeviceAssociationRequester();

const useVehicleDeviceAssociation = () => {
  const getVehicleDeviceAssociationsByDevice = (params?: VehicleDeviceAssociationInfoInput) =>
    useQuery<VehicleDeviceAssociationInfoResponse>({
      queryKey: [`${QUERY_KEY}_BY_DEVICE`, JSON.stringify(params)],
      queryFn: () => getGraphQLVehicleDeviceAssociationRequester().getVehicleDeviceAssociationsByDevice(params),
    });

  const getVehicleDeviceAssociationsByVehicle = (params?: VehicleDeviceAssociationInfoInput) =>
    useQuery<VehicleDeviceAssociationInfoResponse>({
      queryKey: [`${QUERY_KEY}_BY_VEHICLE`, JSON.stringify(params)],
      queryFn: () => getGraphQLVehicleDeviceAssociationRequester().getVehicleDeviceAssociationsByVehicle(params),
    });

  return {
    getVehicleDeviceAssociationsByDevice,
    getVehicleDeviceAssociationsByVehicle,
  };
};

export default useVehicleDeviceAssociation;
